import {makeAutoObservable, observable, action} from 'mobx'
import authStore from "../AuthStore/AuthStore";
import {getChildrenList} from "../../Request/api/Childrens/getChildrenList";
import modalStore from "../../Components/modal/modalStore";
import {getPlayerStats} from "../../Request/api/Olymp/getPlayerStats";
import {getPlayerStatsTutor} from "../../Request/api/Olymp/getPlayerStatTutor"
import {getGroupStats} from "../../Request/api/Olymp/getGroupStats";
import childGroupsStore from "../ChildGroups/ChildGroupsStore";

class ReportStore {
    @observable ChildList = [];
    @observable ChildSelectId = null;
    @observable SelectedLevel = null;
    @observable PlayStats = null;
    @observable gamesTime = [];
    @observable percentGamesOnLevel = null;
    @observable percentsByGame = [];
    @observable totalTime = null;
    @observable bestGame = null;
    @observable worseGame = null;
    colorList = [
        [//NATURAL COLOR
            '#5D9CEC', //BLUE JEANS
            '#4FC1E9', //AQUA
            '#48CFAD', //MINT
            '#A0D468', //GRASS
            '#FFCE54', //SUNFLOWER
            '#FC6E51', //BITTERSWEET
            '#ED5565', //GRAPEFRUIT
            '#AC92EC', //LAVENDER
            '#EC87C0', //PINK ROSE
            '#F5F7FA', //LIGHT GRAY
            '#CCD1D9', //MEDIUM GRAY
            '#656D78', //DARK GRAY
        ],
        [ //SHADE COLOR
            '#4A89DC', //SHADE BLUE JEANS
            '#3BAFDA', //SHADE AQUA
            '#37BC9B', //SHADE MINT
            '#8CC152', //SHADE GRASS
            '#F6BB42', //SHADE SUNFLOWER
            '#E9573F', //SHADE BITTERSWEET
            '#DA4453', //SHADE GRAPEFRUIT
            '#967ADC', //SHADE LAVENDER
            '#D770AD', //SHADE PINK ROSE
            '#E6E9ED', //SHADE LIGHT GRAY
            '#AAB2BD', //SHADE MEDIUM GRAY
            '#434A54', //SHADE DARK GRAY
        ]
    ]
    iter = 0;

    isChildren = false;
    activeID = null;
    groupActiveID = null; //Активная группа в массиве групп
    childActiveID = null; //Активный ребенок в массиве детей группы

    levelOlymp = null;
    levelData = null;


    constructor() {
        makeAutoObservable(this);
    }

    getRandomColor(iter){
        if(iter <= 11)
            return this.colorList[0][iter];
        else if(iter > 11)
            return this.colorList[1][iter];
        else
            return '#'+(0x1000000+(Math.random())*0xffffff).toString(16).substr(1,6);
    }

    SelectLevel(level){
        this.SelectedLevel = level;
        this.prevStrokeDash = 25;
        this.prevPercent = 100;

        //Делаем выборку данных под уровень
        if(this.PlayStats.length === 0){
            return null;
        }

        this.gamesTime = this.PlayStats.gamesTime.map((elem) => {
            if(elem.PlayerDifficulty === level-1){
                elem.color = this.getRandomColor(this.iter);
                this.iter ++;
                return elem;
            }
            else
               return null;
        }).filter(n => n)
        this.iter = 0;

        this.percentGamesOnLevel = this.PlayStats.percentGamesOnLevel.map(elem => {
            if(elem.diff === level-1)
                return elem;
            else
                return null;
        }).filter(n => n)

        // this.percentsByGame = this.PlayStats.percentsByGame.map(elem => {
        //     if(elem.PlayerDifficulty === level-1)
        //         return elem;
        //     else
        //         return null;
        // }).filter(n => n)

        this.percentsByGame = this.PlayStats.percentsByGame.filter( item => item.PlayerDifficulty === level-1)

        this.totalTime = this.PlayStats[`totalLevel${level}Time`]

        let PercentSecondList = [];
        for(let game = 0; game < this.percentsByGame.length; game++){
            for(let game1 = 0; game1 < this.gamesTime.length; game1++){
                if(this.percentsByGame[game].LevelName === this.gamesTime[game1].LevelName){
                    let newObj = {};

                    Object.keys(this.percentsByGame[game]).forEach(key => newObj[key] = this.percentsByGame[game][key]);
                    Object.keys(this.gamesTime[game1]).forEach(key => newObj[key] = this.gamesTime[game1][key]);

                    PercentSecondList.push(newObj);
                }
            }
        }


        PercentSecondList.map(game => {
            game.LevelName = Base64.decode(game.LevelName);
            return null;
        })





        PercentSecondList = this.sortGamePersentOfCecond(PercentSecondList)

        //Лучшая игра
        this.bestGame = PercentSecondList[0].game
        let worseGame = PercentSecondList[1]
        for (let i = 2; i < PercentSecondList.length; i++ ){

            if(PercentSecondList[i].persentOfSecond > 0){
                (PercentSecondList[i].persentOfSecond < worseGame.persentOfSecond) && (worseGame = PercentSecondList[i])
            }
        }
        //Худшая игра
        this.worseGame = worseGame.game


        // если все игры были плохими но в них провели время
        if(this.bestGame.Percent == 0 && this.worseGame.Percent == 0){
            this.bestGame.LevelName = "Пока нет данных"
            this.bestGame.Seconds = 0
        }
        //this.bestGame = this.findBestOrWorseGame(JSON.parse(JSON.stringify(this.sortBySubField(PercentSecondList, 'Percent', true))), false);
        //this.worseGame = this.findBestOrWorseGame(JSON.parse(JSON.stringify(this.sortBySubField(PercentSecondList, 'Percent', false))), true);

    }

    findBestOrWorseGame(list, orderBy){
        return JSON.parse(JSON.stringify(
            this.sortBySubField(
                list.filter(
                    (game) => {return game.Percent === list[0].Percent}
                    ), 'Seconds', orderBy)[0]))
    }

    sortBySubField(list, field, orderBy) {
        list.sort(function (a, b){
            if(a[field] > b[field])
                return orderBy? -1 : 1
            else if(a[field] < b[field])
                return orderBy? 1 : -1
            else
                return 0
        })

        return list
    }
    // Новое определение лучшей и хуждей игры
     sortGamePersentOfCecond = (gamesList) => {
        let persentOfSecond = gamesList.map(item => {
             if (item.Seconds > 0 && item.Percent > 0) {
                 return {
                     persentOfSecond: item.Percent / item.Seconds * 100,
                     game: item,
                 }
             } else if (item.Seconds > 0 && item.Percent == 0) {
                 return {
                     persentOfSecond: 0.0001 / item.Seconds * 100,
                     game: item,
                 }
             } else {
                 item.LevelName = "Пока нет данных"
                 return {
                     persentOfSecond: 0,
                     game: item,
                 }
             }
         })

         persentOfSecond = this.sortBySubField(persentOfSecond, 'persentOfSecond', true)


         return persentOfSecond

    }

    async GetChldrensList(){
        if(authStore.isAuth){
            this.ChildList = await getChildrenList().then(r => {
                if(r !== null && r.type === 'Data'){
                    this.GetPlayerStats(r.data[0].UserId);

                    return r.data;
                } else {
                    modalStore.SetModalInfo("Произошла ошибка", "Ошибка")
                    modalStore.simpleModalOpen();
                    return [];
                }
            })
        }
    }

    async GetPlayerStats(id){
        if(authStore.isAuth){
            this.ChildSelectId = id;
            this.PlayStats = await getPlayerStats(id).then(r => {
                if(r !== null && r.type === 'Data'){
                    return JSON.parse(r.data.Data);
                } else {
                    if(!r?.message){
                        modalStore.SetModalInfo("Произошла ошибка", "Ошибка")
                        modalStore.simpleModalOpen();
                    } else if(r.message === "NoContent"){} else {
                        modalStore.SetModalInfo("Произошла ошибка", "Ошибка")
                        modalStore.simpleModalOpen();
                    }

                    return [];
                }
            })
            this.SelectLevel(this.levelOlymp+1);
        }
    }

    //Получение статы ребенка для Педагога
    async GetPlayerStatsTutor(id){
        if(authStore.isAuth){
            this.ChildSelectId = id;
            this.PlayStats = await getPlayerStatsTutor(id).then(r => {
                if(r !== null && r.type === 'Data'){
                    return JSON.parse(r.data.Data);
                } else {
                    if(!r?.message){
                        modalStore.SetModalInfo("Произошла ошибка", "Ошибка")
                        modalStore.simpleModalOpen();
                    } else if(r.message === "NoContent"){} else {
                        modalStore.SetModalInfo("Произошла ошибка", "Ошибка")
                        modalStore.simpleModalOpen();
                    }

                    return [];
                }
            })
            this.SelectLevel(this.levelOlymp+1);
        }
    }


    async GetGroupStats(id){
        if(authStore.isAuth){
            this.levelData = await getGroupStats(id).then(r => {

                if(r !== null && r.type === 'Data'){
                    return JSON.parse(r.data);
                } else {
                    //Не нужно тут модальное окно, портит ux
                    // if(!r?.message){
                    //     modalStore.SetModalInfo("Произошла ошибка", "Ошибка")
                    //     modalStore.simpleModalOpen();
                    // } else if(r.message === "NoContent"){} else {
                    //     modalStore.SetModalInfo("Произошла ошибка", "Ошибка")
                    //     modalStore.simpleModalOpen();
                    // }

                    return null;
                }
            })

        }
    }

    declOfNum(number, titles) { //declOfNum(442, ['минута','минуты','минут'])
        let cases = [2, 0, 1, 1, 1, 2];
        return titles[ (number%100>4 && number%100<20)? 2 : cases[(number%10<5)?number%10:5] ];
    }

    setIsChildren = () => {
        this.isChildren = !this.isChildren
        if (this.isChildren == false) { this.childActiveID = null}
    }

    //Экшены для смены ID ребенка или группы
    setID(id){
        if (this.isChildren) {
            this.setReportChildID(id)
            this.levelOlymp = null
        } else {
            this.setReportGroupID(id)
            this.setReportChildID(null)
            this.levelOlymp = null
        }

    }

    setLevelOlymp = (id) => {
        this.levelOlymp = id
    }

    setReportChildID = (id) =>{

            this.childActiveID = id;


    }

    setLevelData = async (groupID) => {
       await this.GetGroupStats(groupID)
    }

    setReportGroupID(id){
        this.groupActiveID = id;
        childGroupsStore.setGroupChildID(id)
    }


}

const reportStore = new ReportStore();

export default reportStore;

export var Base64 = {_keyStr: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", encode: function(input) {var output = "";var chr1, chr2, chr3, enc1, enc2, enc3, enc4;var i = 0;input = Base64._utf8_encode(input);while (i < input.length) {chr1 = input.charCodeAt(i++);chr2 = input.charCodeAt(i++);chr3 = input.charCodeAt(i++);enc1 = chr1 >> 2;enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);enc4 = chr3 & 63;if (isNaN(chr2)) {enc3 = enc4 = 64;} else if (isNaN(chr3)) {enc4 = 64;}output = output + this._keyStr.charAt(enc1) + this._keyStr.charAt(enc2) + this._keyStr.charAt(enc3) + this._keyStr.charAt(enc4);}return output;}, decode: function(input) {var output = "";var chr1, chr2, chr3;var enc1, enc2, enc3, enc4;var i = 0;input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");while (i < input.length) {enc1 = this._keyStr.indexOf(input.charAt(i++));enc2 = this._keyStr.indexOf(input.charAt(i++));enc3 = this._keyStr.indexOf(input.charAt(i++));enc4 = this._keyStr.indexOf(input.charAt(i++));chr1 = (enc1 << 2) | (enc2 >> 4);chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);chr3 = ((enc3 & 3) << 6) | enc4;output = output + String.fromCharCode(chr1);if (enc3 != 64) {output = output + String.fromCharCode(chr2);}if (enc4 != 64) {output = output + String.fromCharCode(chr3);}}output = Base64._utf8_decode(output);return output;}, _utf8_encode: function(string) {string = string.replace(/\r\n/g, "\n");var utftext = "";for (var n = 0; n < string.length; n++) {var c = string.charCodeAt(n);if (c < 128) {utftext += String.fromCharCode(c);} else if ((c > 127) && (c < 2048)) {utftext += String.fromCharCode((c >> 6) | 192);utftext += String.fromCharCode((c & 63) | 128);} else {utftext += String.fromCharCode((c >> 12) | 224);utftext += String.fromCharCode(((c >> 6) & 63) | 128);utftext += String.fromCharCode((c & 63) | 128);}}return utftext;}, _utf8_decode: function(utftext) {var string = "";var i = 0;var c = 0;var c2 = 0;var c3 = 0;while (i < utftext.length) {c = utftext.charCodeAt(i);if (c < 128) {string += String.fromCharCode(c);i++;}else if ((c > 191) && (c < 224)) {c2 = utftext.charCodeAt(i + 1);string += String.fromCharCode(((c & 31) << 6) | (c2 & 63));i += 2;} else {c2 = utftext.charCodeAt(i + 1);c3 = utftext.charCodeAt(i + 2);string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));i += 3;}}return string;}}